import {
  EmployeeInputCode,
  FarmInputCode,
  FertilizerInputCode,
  IAmountUnits,
  InputGroupCode,
  MachineryInputCode,
  PesticideInputCode,
  SeedInputCode,
  UnitTitle,
  UnitValue,
} from './unit.types';

const createUnit = (value: UnitValue, title: UnitTitle) => ({value, title});

// ---------------------- amount units ---------------------

export const AmountUnitsConfig: IAmountUnits = {
  // sale Layer
  sale: {
    // Fertilizer Group (11)
    [InputGroupCode.FERTILIZER]: {
      // Default fertilizers - amount units
      [FertilizerInputCode.DEFAULT]: [
        createUnit(UnitValue.GRAM, UnitTitle.GRAM),
        createUnit(UnitValue.KILOGRAM, UnitTitle.KILOGRAM),
        createUnit(UnitValue.LITER, UnitTitle.LITER),
        createUnit(UnitValue.TON, UnitTitle.TON),
        createUnit(UnitValue.MILLILITER, UnitTitle.MILLILITER),
      ],

      // Animal fertilizer (دامی) - amount units
      [FertilizerInputCode.ANIMAL]: [
        createUnit(UnitValue.GRAM, UnitTitle.GRAM),
        createUnit(UnitValue.KILOGRAM, UnitTitle.KILOGRAM),
        createUnit(UnitValue.LITER, UnitTitle.LITER),
        createUnit(UnitValue.TON, UnitTitle.TON),
      ],
    },

    // Pesticide Group (12)
    [InputGroupCode.PESTICIDE]: {
      [PesticideInputCode.DEFAULT]: [
        createUnit(UnitValue.GRAM, UnitTitle.GRAM),
        createUnit(UnitValue.KILOGRAM, UnitTitle.KILOGRAM),
        createUnit(UnitValue.LITER, UnitTitle.LITER),
        createUnit(UnitValue.MILLILITER, UnitTitle.MILLILITER),
      ],
      [PesticideInputCode.OTHER]: [
        createUnit(UnitValue.GRAM, UnitTitle.GRAM),
        createUnit(UnitValue.KILOGRAM, UnitTitle.KILOGRAM),
        createUnit(UnitValue.LITER, UnitTitle.LITER),
        createUnit(UnitValue.MILLILITER, UnitTitle.MILLILITER),
        createUnit(UnitValue.NUMBER, UnitTitle.NUMBER),
        createUnit(UnitValue.PACK, UnitTitle.BOX), // in the database the seed has no box so the value should be pack but the label should be Box
      ],
    },
    // Seed Group (13)
    [InputGroupCode.SEED]: {
      [SeedInputCode.SEED]: [
        createUnit(UnitValue.GRAM, UnitTitle.GRAM),
        createUnit(UnitValue.KILOGRAM, UnitTitle.KILOGRAM),
        createUnit(UnitValue.NUMBER, UnitTitle.NUMBER),
        createUnit(UnitValue.BOX, UnitTitle.BOX),
        createUnit(UnitValue.TON, UnitTitle.TON),
      ],
      [SeedInputCode.SEEDLING]: [createUnit(UnitValue.TRUNK, UnitTitle.TRUNK)],
      [SeedInputCode.TRANSPLANT]: [
        createUnit(UnitValue.NUMBER, UnitTitle.NUMBER),
        createUnit(UnitValue.TRUNK, UnitTitle.TRUNK),
      ],
      [SeedInputCode.CUTTING_GRAFT]: [
        createUnit(UnitValue.NUMBER, UnitTitle.NUMBER),
        createUnit(UnitValue.TRUNK, UnitTitle.TRUNK),
      ],
    },

    // Machinery Group (15)
    [InputGroupCode.MACHINERY]: {
      [MachineryInputCode.DEFAULT]: [
        createUnit(UnitValue.DEVICE, UnitTitle.DEVICE),
      ],
    },

    // Tool Group (16)
    // Tools handled on another function (filterToolsInputGroups)

    // Farm And Water Group (17)
    [InputGroupCode.FARM]: {
      [FarmInputCode.FARM]: [
        createUnit(UnitValue.HECTARE, UnitTitle.HECTARE),
        createUnit(UnitValue.SQUARE_METER, UnitTitle.SQUARE_METER),
        createUnit(UnitValue.HEAD, UnitTitle.HEAD),
        createUnit(UnitValue.PIECE, UnitTitle.PIECE),
        createUnit(UnitValue.UNIT, UnitTitle.UNIT),
      ],
      [FarmInputCode.IRRIGATION]: [
        createUnit(UnitValue.HOUR, UnitTitle.HOUR),
        createUnit(UnitValue.DAY, UnitTitle.DAY),
        createUnit(UnitValue.MONTH, UnitTitle.MONTH),
        createUnit(UnitValue.YEAR, UnitTitle.YEAR),
      ],
    },
  },

  // Buy Layer
  buy: {
    // Fertilizer Group (11)
    [InputGroupCode.FERTILIZER]: {
      // Default fertilizers - amount units
      [FertilizerInputCode.DEFAULT]: [
        createUnit(UnitValue.GRAM, UnitTitle.GRAM),
        createUnit(UnitValue.KILOGRAM, UnitTitle.KILOGRAM),
        createUnit(UnitValue.LITER, UnitTitle.LITER),
        createUnit(UnitValue.TON, UnitTitle.TON),
        createUnit(UnitValue.MILLILITER, UnitTitle.MILLILITER),
      ],

      // Animal fertilizer (دامی) - amount units
      [FertilizerInputCode.ANIMAL]: [
        createUnit(UnitValue.GRAM, UnitTitle.GRAM),
        createUnit(UnitValue.KILOGRAM, UnitTitle.KILOGRAM),
        createUnit(UnitValue.LITER, UnitTitle.LITER),
        createUnit(UnitValue.TON, UnitTitle.TON),
      ],
    },

    // Pesticide Group (12)
    [InputGroupCode.PESTICIDE]: {
      [PesticideInputCode.DEFAULT]: [
        createUnit(UnitValue.GRAM, UnitTitle.GRAM),
        createUnit(UnitValue.KILOGRAM, UnitTitle.KILOGRAM),
        createUnit(UnitValue.LITER, UnitTitle.LITER),
        createUnit(UnitValue.MILLILITER, UnitTitle.MILLILITER),
      ],
      [PesticideInputCode.OTHER]: [
        createUnit(UnitValue.GRAM, UnitTitle.GRAM),
        createUnit(UnitValue.KILOGRAM, UnitTitle.KILOGRAM),
        createUnit(UnitValue.LITER, UnitTitle.LITER),
        createUnit(UnitValue.MILLILITER, UnitTitle.MILLILITER),
        createUnit(UnitValue.NUMBER, UnitTitle.NUMBER),
        createUnit(UnitValue.PACK, UnitTitle.BOX), // in the database the seed has no box so the value should be pack but the label should be Box
      ],
    },
    // Seed Group (13)
    [InputGroupCode.SEED]: {
      [SeedInputCode.SEED]: [
        createUnit(UnitValue.GRAM, UnitTitle.GRAM),
        createUnit(UnitValue.KILOGRAM, UnitTitle.KILOGRAM),
        createUnit(UnitValue.NUMBER, UnitTitle.NUMBER),
        createUnit(UnitValue.BOX, UnitTitle.BOX),
        createUnit(UnitValue.TON, UnitTitle.TON),
      ],
      [SeedInputCode.SEEDLING]: [createUnit(UnitValue.TRUNK, UnitTitle.TRUNK)],
      [SeedInputCode.TRANSPLANT]: [
        createUnit(UnitValue.NUMBER, UnitTitle.NUMBER),
        createUnit(UnitValue.TRUNK, UnitTitle.TRUNK),
      ],
      [SeedInputCode.CUTTING_GRAFT]: [
        createUnit(UnitValue.NUMBER, UnitTitle.NUMBER),
        createUnit(UnitValue.TRUNK, UnitTitle.TRUNK),
      ],
    },

    // Machinery Group (15)
    [InputGroupCode.MACHINERY]: {
      [MachineryInputCode.DEFAULT]: [
        createUnit(UnitValue.DEVICE, UnitTitle.DEVICE),
        createUnit(UnitValue.NUMBER, UnitTitle.NUMBER),
      ],
    },

    // Tool Group (16)
    // Tools handled on another function (filterToolsInputGroups)

    // Farm And Water Group (17)
    [InputGroupCode.FARM]: {
      [FarmInputCode.FARM]: [
        createUnit(UnitValue.HECTARE, UnitTitle.HECTARE),
        createUnit(UnitValue.SQUARE_METER, UnitTitle.SQUARE_METER),
        createUnit(UnitValue.HEAD, UnitTitle.HEAD),
        createUnit(UnitValue.PIECE, UnitTitle.PIECE),
        createUnit(UnitValue.UNIT, UnitTitle.UNIT),
      ],
      [FarmInputCode.IRRIGATION]: [
        createUnit(UnitValue.HOUR, UnitTitle.HOUR),
        createUnit(UnitValue.DAY, UnitTitle.DAY),
        createUnit(UnitValue.MONTH, UnitTitle.MONTH),
        createUnit(UnitValue.YEAR, UnitTitle.YEAR),
      ],
    },
  },

  // Provided Service Layer
  providedService: {
    // Machinery Group (15) - Service units
    [InputGroupCode.MACHINERY]: {
      [MachineryInputCode.DEFAULT]: [
        createUnit(UnitValue.PER_HOUR, UnitTitle.PER_HOUR),
        createUnit(UnitValue.PER_HECTARE, UnitTitle.PER_HECTARE),
      ],
    },

    // Employee Group (14) - Service units
    [InputGroupCode.EMPLOYEE]: {
      [EmployeeInputCode.DEFAULT]: [
        createUnit(UnitValue.HOURLY, UnitTitle.HOURLY),
        createUnit(UnitValue.DAILY, UnitTitle.DAILY),
        createUnit(UnitValue.MONTHLY, UnitTitle.MONTHLY),
      ],
    },
  },

  // Provided Rent Layer
  providedRent: {
    // Machinery Group (15) - Rent units
    [InputGroupCode.MACHINERY]: {
      [MachineryInputCode.DEFAULT]: [
        createUnit(UnitValue.PER_HOUR, UnitTitle.PER_HOUR),
        createUnit(UnitValue.PER_HECTARE, UnitTitle.PER_HECTARE),
      ],
    },

    // Farm Group (17) - Rent units
    [InputGroupCode.FARM]: {
      [FarmInputCode.FARM]: [
        createUnit(UnitValue.MONTHLY, UnitTitle.MONTHLY),
        createUnit(UnitValue.YEARLY, UnitTitle.YEARLY),
      ],
      [FarmInputCode.IRRIGATION]: [
        createUnit(UnitValue.HOURLY, UnitTitle.HOURLY),
        createUnit(UnitValue.DAILY, UnitTitle.DAILY),
        createUnit(UnitValue.MONTHLY, UnitTitle.MONTHLY),
        createUnit(UnitValue.YEARLY, UnitTitle.YEARLY),
        createUnit(UnitValue.LITRE, UnitTitle.LITRE),
        createUnit(UnitValue.CUBIC_METER, UnitTitle.CUBIC_METER),
        createUnit(UnitValue.PER_SECOND, UnitTitle.PER_SECOND),
        createUnit(UnitValue.PER_DAY, UnitTitle.PER_DAY),
        createUnit(UnitValue.PER_HOUR, UnitTitle.PER_HOUR),
      ],
    },
  },

  // Wanted Rent Layer
  wantedRent: {
    // Machinery Group (15) - Rent units
    [InputGroupCode.MACHINERY]: {
      [MachineryInputCode.DEFAULT]: [
        createUnit(UnitValue.HOUR, UnitTitle.HOUR),
        createUnit(UnitValue.DAY, UnitTitle.DAY),
        createUnit(UnitValue.MONTH, UnitTitle.MONTH),
      ],
    },

    // Farm Group (17) - Rent units
    [InputGroupCode.FARM]: {
      [FarmInputCode.FARM]: [
        createUnit(UnitValue.HECTARE, UnitTitle.HECTARE),
        createUnit(UnitValue.SQUARE_METER, UnitTitle.SQUARE_METER),
      ],
      [FarmInputCode.IRRIGATION]: [
        createUnit(UnitValue.HOUR, UnitTitle.HOUR),
        createUnit(UnitValue.DAY, UnitTitle.DAY),
        createUnit(UnitValue.MONTH, UnitTitle.MONTH),
        createUnit(UnitValue.YEAR, UnitTitle.YEAR),
      ],
    },
  },

  // had to add this because the edit uses a different srs_type?.type than the submit. don't hate me, hate the old backend this is for the edit of provided service
  // Wanted Service Layer
  service: {
    [InputGroupCode.MACHINERY]: {
      [MachineryInputCode.DEFAULT]: [
        createUnit(UnitValue.PER_HOUR, UnitTitle.PER_HOUR),
        createUnit(UnitValue.PER_HECTARE, UnitTitle.PER_HECTARE),
      ],
    },
    [InputGroupCode.EMPLOYEE]: {
      [EmployeeInputCode.DEFAULT]: [
        createUnit(UnitValue.HOUR, UnitTitle.HOUR),
        createUnit(UnitValue.DAY, UnitTitle.DAY),
        createUnit(UnitValue.MONTH, UnitTitle.MONTH),
        createUnit(UnitValue.YEAR, UnitTitle.YEAR),
      ],
    },
  },

  wantedService: {
    [InputGroupCode.MACHINERY]: {
      [MachineryInputCode.DEFAULT]: [
        createUnit(UnitValue.PER_HOUR, UnitTitle.PER_HOUR),
        createUnit(UnitValue.PER_HECTARE, UnitTitle.PER_HECTARE),
      ],
    },
    [InputGroupCode.EMPLOYEE]: {
      [EmployeeInputCode.DEFAULT]: [
        createUnit(UnitValue.HOUR, UnitTitle.HOUR),
        createUnit(UnitValue.DAY, UnitTitle.DAY),
        createUnit(UnitValue.MONTH, UnitTitle.MONTH),
        createUnit(UnitValue.YEAR, UnitTitle.YEAR),
      ],
    },
  },
};

// ---------------------- time units ---------------------

export const PriceUnitsConfig: IAmountUnits = {
  sale: {
    [InputGroupCode.FARM]: {
      [FarmInputCode.IRRIGATION]: [
        createUnit(UnitValue.HOURLY, UnitTitle.HOURLY),
        createUnit(UnitValue.DAILY, UnitTitle.DAILY),
        createUnit(UnitValue.MONTHLY, UnitTitle.MONTHLY),
        createUnit(UnitValue.YEARLY, UnitTitle.YEARLY),
      ],
    },
  },
  providedService: {
    [InputGroupCode.MACHINERY]: {
      [MachineryInputCode.DEFAULT]: [
        createUnit(UnitValue.PER_HOUR, UnitTitle.PER_HOUR),
        createUnit(UnitValue.PER_HECTARE, UnitTitle.PER_HECTARE),
      ],
    },
    [InputGroupCode.EMPLOYEE]: {
      [EmployeeInputCode.DEFAULT]: [
        createUnit(UnitValue.HOURLY, UnitTitle.HOURLY),
        createUnit(UnitValue.DAILY, UnitTitle.DAILY),
        createUnit(UnitValue.MONTHLY, UnitTitle.MONTHLY),
      ],
    },
  },

  // had to add this because the edit uses a different srs_type?.type than the submit. don't hate me, hate the old backend this is for the edit of provided service
  service: {
    [InputGroupCode.MACHINERY]: {
      [MachineryInputCode.DEFAULT]: [
        createUnit(UnitValue.PER_HOUR, UnitTitle.PER_HOUR),
        createUnit(UnitValue.PER_HECTARE, UnitTitle.PER_HECTARE),
      ],
    },
    [InputGroupCode.EMPLOYEE]: {
      [EmployeeInputCode.DEFAULT]: [
        createUnit(UnitValue.HOURLY, UnitTitle.HOURLY),
        createUnit(UnitValue.DAILY, UnitTitle.DAILY),
        createUnit(UnitValue.MONTHLY, UnitTitle.MONTHLY),
      ],
    },
  },

  wantedService: {
    [InputGroupCode.MACHINERY]: {
      [MachineryInputCode.DEFAULT]: [
        createUnit(UnitValue.PER_HOUR, UnitTitle.PER_HOUR),
        createUnit(UnitValue.PER_HECTARE, UnitTitle.PER_HECTARE),
      ],
    },
    [InputGroupCode.EMPLOYEE]: {
      [EmployeeInputCode.DEFAULT]: [
        createUnit(UnitValue.HOUR, UnitTitle.HOUR),
        createUnit(UnitValue.DAY, UnitTitle.DAY),
        createUnit(UnitValue.MONTH, UnitTitle.MONTH),
        createUnit(UnitValue.YEAR, UnitTitle.YEAR),
      ],
    },
  },

  providedRent: {
    [InputGroupCode.MACHINERY]: {
      [MachineryInputCode.DEFAULT]: [
        createUnit(UnitValue.PER_HOUR, UnitTitle.PER_HOUR),
        createUnit(UnitValue.PER_HECTARE, UnitTitle.PER_HECTARE),
      ],
    },
    [InputGroupCode.FARM]: {
      [FarmInputCode.FARM]: [
        createUnit(UnitValue.MONTHLY, UnitTitle.MONTHLY),
        createUnit(UnitValue.YEARLY, UnitTitle.YEARLY),
      ],
      [FarmInputCode.IRRIGATION]: [
        createUnit(UnitValue.HOURLY, UnitTitle.HOURLY),
        createUnit(UnitValue.DAILY, UnitTitle.DAILY),
        createUnit(UnitValue.MONTHLY, UnitTitle.MONTHLY),
        createUnit(UnitValue.YEARLY, UnitTitle.YEARLY),
      ],
    },
  },

  wantedRent: {
    [InputGroupCode.MACHINERY]: {
      [MachineryInputCode.DEFAULT]: [
        createUnit(UnitValue.HOUR, UnitTitle.HOUR),
        createUnit(UnitValue.DAY, UnitTitle.DAY),
        createUnit(UnitValue.MONTH, UnitTitle.MONTH),
      ],
    },
    [InputGroupCode.FARM]: {
      [FarmInputCode.FARM]: [
        createUnit(UnitValue.HECTARE, UnitTitle.HECTARE),
        createUnit(UnitValue.SQUARE_METER, UnitTitle.SQUARE_METER),
      ],
      [FarmInputCode.IRRIGATION]: [
        createUnit(UnitValue.HOUR, UnitTitle.HOUR),
        createUnit(UnitValue.DAY, UnitTitle.DAY),
        createUnit(UnitValue.MONTH, UnitTitle.MONTH),
        createUnit(UnitValue.YEAR, UnitTitle.YEAR),
      ],
    },
  },
};

// ---------------------- attribute units ---------------------\

export const IrrigationAttributesUnits = [
  // unit of the amount of water : irrigation_volume_unit
  [
    createUnit(UnitValue.LITRE, UnitTitle.LITRE),
    createUnit(UnitValue.CUBICMETER, UnitTitle.CUBICMETER),
  ],
  //  unit of the per duration of water : irrigation_volume_time
  [
    createUnit(UnitValue.SECOND, UnitTitle.PER_SECOND),
    // these cases bellow are special as you can see teh label and value do not match
    createUnit(UnitValue.HOURLY, UnitTitle.PER_HOUR),
    createUnit(UnitValue.DAILY, UnitTitle.PER_DAY),
  ],
];

// ---------------------- exception  units collection ------------------------\

export const WantedRentFarmDurationUnits = [
  createUnit(UnitValue.MONTH, UnitTitle.MONTH),
  createUnit(UnitValue.YEAR, UnitTitle.YEAR),
];

export const WantedRentIrrigationDurationUnits = [
  createUnit(UnitValue.HOUR, UnitTitle.HOUR),
  createUnit(UnitValue.DAY, UnitTitle.DAY),
  createUnit(UnitValue.MONTH, UnitTitle.MONTH),
  createUnit(UnitValue.YEAR, UnitTitle.YEAR),
];
